import flatten from "ramda/es/flatten"
import map from "ramda/es/map"
import filter from "ramda/es/filter"
import { parseISO } from "datastory-shared/utils/date"

const getPollLineDatums = (pollster, data) => party => ({
  id: party,
  pollster,
  values: map(
    getPartyDatum,
    filter(d => d.og_pollster === pollster, data)
  ),
})

const pollLineParser = (data, parties) => pollster =>
  map(getPollLineDatums(pollster, data), parties)

const getPollLines = (data, parties, pollsters) =>
  flatten(map(pollLineParser(data, parties), pollsters))

const getPartyDatum = d => ({
  date: parseISO(d.og_date),
  value: d.og_value,
})

const partyParser = data => id => ({
  id,
  values: map(
    getPartyDatum,
    filter(d => d.og_politicalParty === id, data)
  ),
})

const getPartyTrends = (data, partyIds) => map(partyParser(data), partyIds)

const getPollDatum = d => p => ({
  date: parseISO(d.og_date),
  value: d.og_value,
  id: p,
  pollster: d.og_pollster,
})

const pollParser = ids => d => map(getPollDatum(d), ids)

const getPollsData = (data, partyIds) =>
  flatten(map(pollParser(partyIds), data))

export { getPartyTrends, getPollsData, getPollLines }
